import { render, staticRenderFns } from "./RequestPriceList.vue?vue&type=template&id=347eafdc"
import script from "./RequestPriceList.vue?vue&type=script&lang=js"
export * from "./RequestPriceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports